import React from "react";
import { RichTextElement } from "@kontent-ai/gatsby-components";
import ReferenceComponent from "../components";
import { KontentComponent, KontentRichText, StringValue } from "../types";

interface Props {
  systemId: string;
  elements: {
    content_components__content: KontentRichText;
  };
}

export const PageComponents: React.FC<Props> = ({ systemId, elements }) => {
  return (
    <div className="page-components" data-kontent-item-id={systemId}>
      {elements?.content_components__content ? (
        <RichTextElement
          data-kontent-element-codename="content_components__content"
          value={elements.content_components__content.value}
          images={elements.content_components__content.images}
          links={elements.content_components__content.links}
          linkedItems={elements.content_components__content.modular_content}
          resolveLinkedItem={(item: KontentComponent) => {
            return (
              <ReferenceComponent
                name={item?.internal?.type}
                key={item?.system?.id}
                id={item?.system?.id}
                pageId={systemId}
                {...item?.elements}
              />
            );
          }}
        />
      ) : null}
    </div>
  );
};
